"use strict";

exports.__esModule = true;
exports.default = exports.MessageContext = void 0;

var _react = require("react");

var MessageContext = /*#__PURE__*/(0, _react.createContext)({
  scope: ''
});
exports.MessageContext = MessageContext;
var _default = MessageContext;
exports.default = _default;